<template>
    <div class="page-content header-clear-medium">

        <div class="card m-3">

            <div class="accordion accordion-m border-0" id="accordion-group-7">

                <div v-for="(kata, index) in show_per_kata_ayat.data" :key="kata.id" class="accordion-item border border-fade-highlight border-bottom-0">
                    <!-- <div class="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#accordion7-2"> -->
                    <div class="d-flex align-items-center">
                        <div class="form-check form-check-custom m-0">
							<input class="form-check-input" @click="checkWord" type="checkbox" :name="kata.id" value="" :id="`c${kata.id}`" :checked="kata.kata_user != null">
							<label class="form-check-label" :for="`c${kata.id}`" style="padding: 3px 14px 3px 14px;">&nbsp;</label>
							<i class="is-checked color-green-dark bi bi-check-circle font-23"></i>
							<i class="is-unchecked color-highlight bi bi-circle font-23"></i>
						</div>

                        <div class="collapsed w-100 d-flex align-items-center justify-content-between px-3 py-2 ps-0 ms-4" data-bs-toggle="collapse" :data-bs-target="`#accordion7-${index}`">
                            <span class="border border-dark p-1 px-2 mx-2" style="font-size: 13px !important;">{{ kata.no }}</span>

                            <div class="d-flex align-items-center justify-content-between">
                                <div dir="rtl">
                                    <div class="badge bg-arab float-right m-1">
                                        <h1 class="arab text-dark arab-first">{{ kata.arab_harokat }}</h1>
                                        <p class="text-black-50 text-terjemahan teksTerjemah mb-4">{{ kata.indonesia }}</p>
                                    </div>
                                </div>
                                <i class="bi bi-chevron-down font-13 color-blue-dark ms-4"></i>
                            </div>
                        </div>
                    </div>
                    
                    <div :id="`accordion7-${index}`" class="accordion-collapse collapse" data-bs-parent="#accordion-group-7">
                        <div class="py-3 px-5" style="background-color: #fffcf5;border: 10px solid #e6e6e6;">
                            <div class="d-flex mb-4 flex-wrap" dir="rtl">
                                <span v-for="kataAyat in kata.ayat.kata" :key="kataAyat.id" class="arab ms-4" style="padding: 2px;">{{ kataAyat.arab_harokat }}</span>
                            </div>
                            <div class="d-flex justify-content-end">
                                <router-link :to="{ name: 'quran.detail', params: {
                                    id: kata.surat_id,
                                    title: kata.ayat.surat.name
                                }}">({{ kata.ayat.no }} : {{ kata.ayat.surat.arab }})</router-link>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>

        <div class="card m-3 d-flex align-items-center p-1">
            <ul class="pagination mt-4 mb-2 flex-wrap justify-content-center">
                <template v-for="(link, key) in show_per_kata_ayat.links" >
                    <li class="page-item mb-2" :key="key" :class="{disabled: link.url === null, 'active': link.active}">
                        <a href="javascript:void(0)" v-html="link.label" class="page-link" @click="getShowPagination(link.url)"/>
                    </li>
                </template>
            </ul>
        </div>

    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
    name: 'Home',
    data() {
        return {
            search: '',
            isBusy: false,
            activeTab: 'quran',
            pageAyat: 1
        }
    },
    created() {
        this.getPerKataAyat()
    },
    methods: {
        ...mapActions('quran', ['getPerKataAyat']),
        ...mapActions('bookmark', ['bookmarkKataUser']),
        setActive (menuItem) {
            this.activeTab = menuItem;
        },
        isActive (menuItem) {
            return this.activeTab === menuItem;
        },
        getShowPagination(urlPage) {
            let split = urlPage.split('=');
            let page = split[1];
            
            this.getPerKataAyat(page);
        },
        checkWord(event) {
            this.bookmarkKataUser({kata_id: event.target.name, status: event.target.checked});
        }
    },
    computed: {
        ...mapState('quran', {
            show_per_kata_ayat: state => state.show_per_kata_ayat
        }),
        // ...mapState([
        //     'terjemahan_bait', 'terjemahan_kata', 'harokat', 'detail'
        // ])
    }
}
</script>

<style scoped>
.arab_count {
    padding : 1px;
    /* margin-bottom: 10px; */
}</style>
